export default {
  getCurrencyIcon: state => currencyId => state.currency.items.find(({ id }) => id === currencyId)?.symbol || '',
  currency: state => state.currency,
  currencyList: state => state.currency.items,
  ['loading']: state => state.loading,
  ['projectTypes']: state => state.projectTypes,
  ['brandDetectionModels']: state => state.brandDetectionModels,
}
